"use client";

import { CopyIcon } from "lucide-react";
import { useTranslations } from "next-intl";
import { type ReactNode } from "react";
import { toast } from "~/components/toaster";

type Props = {
  value: string;
  children?: ReactNode;
  className?: string;
};

export function CopyToClipboard({ value, children, className }: Props) {
  const t = useTranslations("CopyToClipboard");

  return (
    <button
      type="button"
      className={`hoverable inline-flex items-center justify-center rounded bg-transparent transition-colors ${className}`}
      onClick={async (ev) => {
        ev.preventDefault();
        await navigator.clipboard.writeText(value);
        toast.success(t("copied"), { description: value });
      }}
    >
      {children ?? (
        <div className="flex size-6 items-center justify-center text-primary">
          <CopyIcon size={14} />
        </div>
      )}
    </button>
  );
}
